'use client';

import { useUserIdContext } from '@/lib/providers/UserIdProvider';

/**
 * Get current user ID from server-provided context
 * This replaces getCurrentUserId() which reads from localStorage
 * 
 * @returns User ID string or null if not authenticated
 */
export function useUserId(): string | null {
  return useUserIdContext();
}

